import { cn } from "../lib/cn";

export interface BlockIndicatorProps {
  blockNumber?: bigint | number | string | null;
  label?: string;
  live?: boolean;
  size?: "sm" | "md";
  className?: string;
}

export function BlockIndicator({
  blockNumber,
  label = "Block",
  live = true,
  size = "md",
  className,
}: BlockIndicatorProps) {
  const display =
    blockNumber === null || blockNumber === undefined
      ? "..."
      : String(blockNumber);

  return (
    <span
      role="status"
      className={cn(
        "inline-flex items-center gap-1.5 font-mono",
        size === "sm" ? "text-[9px]" : "text-xs",
        className,
      )}
    >
      {live && (
        <span
          className="inline-block h-1.5 w-1.5 animate-[livePulse_2s_ease-in-out_infinite] rounded-full bg-[var(--color-success)] motion-reduce:animate-none"
          aria-hidden="true"
        />
      )}
      <span className="uppercase tracking-wider text-[var(--color-text-dim)]">
        {label}
      </span>
      <span className="text-[var(--color-gold)]">{display}</span>
    </span>
  );
}
